import { Component, OnInit } from "@angular/core";
declare var jquery: any;
declare var $: any;
import { HttpClient } from "@angular/common/http";
import { HttpErrorResponse } from "@angular/common/http";

@Component({
  selector: "app-freelanceHisDetail",
  templateUrl: "./freelanceHisDetail.component.html",
  styleUrls: ["./freelanceHisDetail.component.css"]
})
export class FreelanceHisDetailComponent implements OnInit {

  constructor(
    private httpService: HttpClient
  ) {}

  ngOnInit() {
    this.loadDefaultScript(); 
  } 

  //load default script
  loadDefaultScript() {
     
  }
  //end load default script
}
